<template>
  <InViewport v-if="lazy" @enter="enter" @leave="leave" rootMargin="200px">
    <div>
      <img v-if="showSrc" :alt="alt" :src="src" :class="classes" :style="style" @load="loadedLowSrc = true" />
      <img v-if="showHighSrc" v-show="this.loadedHighSrc" :alt="alt" :src="highSrc" @load="loadedHighSrc = true" :class="classes" :style="style" />
    </div>
  </InViewport>
  <template v-else>
    <img v-if="showSrc" :alt="alt" :src="src" :class="classes" :style="style" @load="loadedLowSrc = true" />
    <img v-if="showHighSrc" v-show="this.loadedHighSrc" :alt="alt" :src="highSrc" @load="loadedHighSrc = true" :class="classes" :style="style" />
  </template>
</template>

<script>
import InViewport from '@/components/InViewport';

export default {
  props: {
    src: { // Image source
      type: String,
      default: null
    },
    highSrc: { // High definition image source, will replace src when its done loading
      type: String,
      default: null
    },
    classes: { // Classes to apply to the image
      type: String,
      default: null
    },
    style: { // Style to apply to the image
      type: Object,
      default: null
    },
    lazy: { // Disable the viewport check
      type: Boolean,
      default: false
    },
    waitForLowSrc: { // Wait for lowsrc to finish before requesting highsrc. Good for minimizing congestion.
      type: Boolean,
      default: true
    },
    alt: {
      type: String,
      default: null
    }
  },
  components: { InViewport },
  data() {
    return {
      isInViewport: ! this.lazy,
      loadedLowSrc: false,
      loadedHighSrc: false,
    }
  },
  computed: {
    showSrc() {
      return this.src && ! this.loadedHighSrc && this.isInViewport;
    },
    showHighSrc() {
      if (this.waitForLowSrc && ! this.loadedLowSrc) {
        return false;
      }
      return this.highSrc && this.isInViewport;
    },
  },
  watch: {
    highSrc() {
      this.loadedHighSrc = false;
    }
  },
  methods: {
    enter() { this.isInViewport = true; },
    leave() { this.isInViewport = false; }
  }
}
</script>